export default __webpack_public_path__ + "static/media/plus-icon.5f03e99a.svg";